/* eslint-disable max-len */
import { useEffect, useState } from "react";
import Popover from "@mui/material/Popover";
import { ThreeDotsIcon } from "assets/Icons";

const ListDotsActions = ({
  children,
  closeFromParent = false,
  setCloseFromParent
}: {
  children: any;
  closeFromParent?: boolean;
  setCloseFromParent?: any;
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const handleClosePopover = (e: any): void => {
    e?.stopPropagation();
    setAnchorEl(null);
  };

  const isPopoverOpen = Boolean(anchorEl);
  const id = isPopoverOpen ? "list-dots-actions-popover" : undefined;

  const handleClick = (event: React.MouseEvent<HTMLDivElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    if (closeFromParent) {
      setCloseFromParent(false);
      setAnchorEl(null);
    }
  }, [closeFromParent, setCloseFromParent]);

  return (
    <div
      className="flex justify-end items-center h-[36px]"
      onClick={(e) => e?.stopPropagation()}
      aria-hidden
    >
      <div
        className="w-[28px] h-[28px] rounded-[14px] flex justify-center items-center cursor-pointer hover:bg-[rgba(48,47,46,0.12)] transition-colors ease-in-out duration-300"
        onClick={handleClick}
        aria-hidden
      >
        <ThreeDotsIcon />
      </div>
      <Popover
        id={id}
        open={isPopoverOpen}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        elevation={4}
        sx={{
          "& .MuiPopover-paper": {
            backgroundColor: "#fff",
            borderRadius: "4px"
          }
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
      >
        {children}
      </Popover>
    </div>
  );
};

export default ListDotsActions;
